import { Card, GridLegacy as Grid, Skeleton } from '@mui/material'

import React, { PropsWithChildren } from 'react'

import ItemCardMedia, { ItemCardMediaProps } from './ItemCardMedia'

const CCItemCard: React.FC<
  PropsWithChildren<
    ItemCardMediaProps & {
      showHighlighted?: boolean
      pendingRemoval?: boolean
      onClick?: () => void
    }
  >
> = ({
  children,
  imageTitle,
  imageUrl,
  vendorAvatar,
  vendorName,
  showHighlighted,
  pendingRemoval,
  onClick = () => {},
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        position: 'relative',
        height: '100%',
        borderColor: showHighlighted ? 'primary.main' : 'none',
        borderWidth: showHighlighted ? '1.5px' : 'initial',
        borderStyle: showHighlighted ? 'solid' : 'initial',
      }}>
      {pendingRemoval ? (
        <Skeleton
          variant="rectangular"
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            backgroundColor: 'rgba(63, 65, 68, 0.9)',
            zIndex: 10,
          }}
        />
      ) : null}
      <Grid container height="100%" direction="row">
        <Grid item xs={12} lg={5}>
          <ItemCardMedia
            vendorAvatar={vendorAvatar}
            vendorName={vendorName}
            imageTitle={imageTitle}
            imageUrl={imageUrl}
          />
        </Grid>
        <Grid
          flexDirection="column"
          display="flex"
          justifyContent="space-between"
          item
          xs={12}
          lg={7}>
          {children}
        </Grid>
      </Grid>
    </Card>
  )
}

export default React.memo(CCItemCard)
